import React, { Component } from 'react';
import { ProgressIndicator } from 'office-ui-fabric-react/lib/ProgressIndicator';

/****************************************************************
 PROPS:
    label
****************************************************************/

export class ProgressIndicatorChargement extends Component {
    constructor(props) {
        super(props);

        this.state = {
            
        };
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    componentDidUpdate() {
    }

    render() {
        return (<div className="divFondProgressIndicator">
            <ProgressIndicator className="progressIndicator" label={this.props.label} />
        </div>);
    }
}
